module.exports = __webpack_public_path__ + "img/TECHNOLOGY-ERTIGA-BOOSTER-GREEN-3.fca3610a.jpg";